import { BrowserRouter, Routes, Route } from 'react-router-dom';
import GamePage from './pages/GamePage';
import VideoUploadPage from './pages/VideoUploadPage';
import EPKPage from './pages/EPKPage';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<EPKPage />} />
        <Route path="/upload" element={<VideoUploadPage />} />
        <Route path="/game" element={<GamePage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
